import React from 'react';

import { routes } from '../../../constants';
import SchoolTeachers from '../../SchoolAdmin/SchoolTeachers';
import useRequireStripeUser from '../useRequireStripeUser';

/**
 * Route wrapper for the legacy `/school/teachers`. A Stripe-billed admin
 * landing here is redirected to `/stripe-school/teachers`. Zuora users pass
 * through and render the untouched legacy `SchoolTeachers` component — no
 * legacy behaviour is modified.
 */
const LegacyTeachersRoute: React.FC = () => {
	const { isReady, matches } = useRequireStripeUser({
		mustBeStripe: false,
		redirectTo: `/${routes.stripeSchoolAdminTeachers.root}`,
	});

	if (!isReady || !matches) return null;

	return <SchoolTeachers />;
};

export default LegacyTeachersRoute;
